/** Reads a JSON-serialised value from localStorage. Returns null on miss or parse error. */
export function readFromStorageCache<T>(key: string): T | null {
  try {
    const raw = localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
}

/** Writes a JSON-serialised value to localStorage. Silently ignores storage errors. */
export function writeToStorageCache<T>(key: string, value: T): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // localStorage unavailable (private mode, quota) — degrade silently
  }
}

/** Removes an entry from localStorage. Silently ignores errors. */
export function removeFromStorageCache(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    // ignore
  }
}
